<template>
  <div class="tableauPlaceHolder">
    <Tableau
      :url="url"
      :height="height"
      :width="width"
      :filters="filters"
      :options="options"
      ref="tableau"
    ></Tableau>
    <div>
      <b-modal
        id="bv-modal-share-link"
        size="xl"
        hide-footer
        title="Share using a link"
      >
        <div b-container fluid>
          <b-row class="share-link-modal-row">
            <b-col>
              <b-form-input
                id="sharedLinkInput"
                readonly
                v-model="sharedLink"
              ></b-form-input>
            </b-col>
            <b-col col sm="3" lg="2">
              <b-button v-on:click="copyToClipboard">
                <span> <i class="fas fa-link"></i>&nbsp; Copy link </span>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Tableau from "@/components/Tableau";
import API from "@aws-amplify/api";
import { BModal } from "bootstrap-vue";
import awsauth from "../awsauth";
import AmplifyStore from "../store";
import EventBus from "../store/eventbus";
API.configure();

export default {
  name: "Dashboard",
  components: {
    Tableau: Tableau,
    "b-modal": BModal,
  },
  data() {
    const envUrl = awsauth.redirectSignIn;
    let env = envUrl.replace("https://", "").split(".")[0];
    console.log(envUrl)
    console.log('yerd')
    switch (env) {
      case "mpr":
        env = "production";
        break;
      case "test":
        env = "test";
        break;
      default:
        // dev, staging, any others
        env = "staging";
        break;
    }
    const url = `https://prod-apsoutheast-a.online.tableau.com/t/besixwatpac/views/MPR-MonthlyProjectReport-production/MPRDashboard?:embed=y&:refresh=yes`;
    return {
      sharedLink: "",
      jobNumber: "",
      month: "",
      year: "",
      width: 1717,
      filters: {},
      options: null,
      url: url,
      env: env,
      envUrl: envUrl + "/",
    };
  },
  created: function() {
    this.options = {
      "p.environment": this.env,
      "p.environmentUrl": this.envUrl,
    };

    if (this.$route.query && this.$route.query.jobNumber) {      
      this.jobNumber = this.$route.query.jobNumber;
      this.year = this.$route.query.year;
      this.month = this.$route.query.month;
    } else {
      AmplifyStore.commit("getRedirectUrl");
      var redirectUrl = AmplifyStore.state.redirectUrl;
      if (redirectUrl && redirectUrl !== "" && redirectUrl !== "null") {        
        AmplifyStore.commit("setRedirectUrl", "");
        if (redirectUrl.indexOf("jobNumber")) {
          const fn = redirectUrl.split('&');
          this.jobNumber = fn[0].split('=')[1].trim();
          if (fn.length > 2) {
            this.year = fn[1].split('=')[1].trim();
            this.month = fn[2].split('=')[1].trim();
          }
        }
      }
    }

    if (this.jobNumber !== "") {
      if ((this.year && this.year !== '' 
          && this.year && this.month !== '') !== true) {
        const today = new Date();
        this.year = today.getFullYear();

        const day = today.getDate();
        let month = today.getMonth();
        month = day > 15 ? month : month - 1;
        if (month < 0) {
          month = 11;
          this.year = this.year - 1;
        }

        this.month = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ][month];        
      }

      this.options = {
        "p.JobNumber": this.jobNumber,
        "p.Year": this.year,
        "p.Month": this.month,
        "p.environment": this.env,
        "p.environmentUrl": this.envUrl,
      };
    }

    const height = window.innerHeight - 27;
    if (height > 900) {
      this.height = height;
    }
  },
  mounted: function() {
    // listen for event
    EventBus.$on("mpr-share-link", this.shareLinkHandler);
    EventBus.$on("mpr-download-file", this.downloadFileHandler);
    EventBus.$on("mpr-undo", this.undoHandler);
    EventBus.$on("mpr-redo", this.redoHandler);
    EventBus.$on("mpr-revert", this.revertFileHandler);
    EventBus.$on("mpr-showExportPDFDialog", this.showExportPDFDialog);
  },
  destroyed: function() {
    // remove listener
    EventBus.$off("mpr-share-link", this.shareLinkHandler);
    EventBus.$off("mpr-download-file", this.downloadFileHandler);
    EventBus.$off("mpr-undo", this.undoHandler);
    EventBus.$off("mpr-redo", this.redoHandler);
    EventBus.$off("mpr-revert", this.revertFileHandler);
    EventBus.$off("mpr-showExportPDFDialog", this.showExportPDFDialog);
  },
  methods: {
    undoHandler: function() {
      this.$refs.tableau.undo();
    },
    redoHandler: function() {
      this.$refs.tableau.redo();
    },
    revertFileHandler: function() {
      this.$refs.tableau.revert();
    },
    showExportPDFDialog: function() {
      this.$refs.tableau.showExportPDFDialog();
    },
    shareLinkHandler: function() {
      this.$refs.tableau.getFilters((filterValues) => {
        if (filterValues) {
          const jobNumber = filterValues["JobNumber"];
          const year = filterValues["Year"];
          const month = filterValues["Month"];
          let sharedUrl = `${awsauth.redirectSignIn}/#/Dashboard?jobNumber=${jobNumber}&year=${year}&month=${month}`;
          this.sharedLink = sharedUrl;
          this.$bvModal.show("bv-modal-share-link");
        }
      });
    },
    downloadFileHandler: function() {
      this.$refs.tableau.getFilters((filterValues) => {
        if (filterValues) {
          const jobNumber = filterValues["JobNumber"];
          const year = filterValues["Year"];
          const month = filterValues["Month"];
          const fileName = `MPR - ${jobNumber} - ${month} ${year}.xlms`;

          const apiName = "mprAPI";
          const path = "/mprGetSourceFile";
          const request = {
            body: {
              name: fileName,
            },
          };

          API.post(apiName, path, request)
            .then((response) => {
              const mprUrl = response.url;
              if (mprUrl && mprUrl !== "") {
                window.open(mprUrl, "_blank");
              } else {
                alert("MPR source file is not found.");
              }
            })
            .catch(() => {});
        }
      });
    },
    copyToClipboard: function() {
      const copyText = document.getElementById("sharedLinkInput");
      copyText.select();
      copyText.setSelectionRange(0, 999);
      document.execCommand("copy");
      this.$bvModal.msgBoxOk("Success: link is copied to clipboard", {
        okVariant: "secondary",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.tableauPlaceHolder {
  margin-left: auto;
  margin-right: auto;
  width: 1717px;
}
.share-link-modal-row {
  margin: 15px 0 15px 0;
}
.modal-dialog button.btn {
  min-width: 80px;
}
</style>
